import axios from 'axios';

const api = axios.create({ headers: { Accept: 'application/json' } });

const SESSION_ROUTE_PREFIXES = ['/api/v1/partner/', '/api/v1/enterprise/'];

let authToken = null;
let failureHandlers = {};

export const setAuthToken = (token) => {
  authToken = token || null;
};

export const setAuthFailureHandlers = (handlers) => {
  failureHandlers = handlers || {};
};

api.interceptors.request.use((config) => {
  // A caller that sets Authorization itself wins: the 2FA endpoints run on a temporary
  // token and must not be overwritten by a session token still held from a prior login.
  if (authToken && !config.headers.Authorization) config.headers.Authorization = `Bearer ${authToken}`;
  return config;
});

api.interceptors.response.use(
  (response) => response,
  (error) => {
    const url = error.config?.url || '';
    // The trailing slash is load-bearing: it exempts /api/v1/partners/login,
    // /api/v1/partners/2fa/* and /api/v1/merchants/agent/*, which handle their own 401/403.
    if (!SESSION_ROUTE_PREFIXES.some((prefix) => url.startsWith(prefix))) return Promise.reject(error);

    const status = error.response?.status;
    const body = error.response?.data;
    // An expired or revoked token comes back as the bare JSON string "Unauthenticated.", not an object.
    const message = typeof body === 'string' ? body : body?.message;

    if (status === 401 || (status === 403 && message === 'Unauthenticated.')) {
      failureHandlers.onUnauthorized?.();
    } else if (status === 403 && message === 'Your account has been deactivated') {
      failureHandlers.onDeactivated?.(message);
    } else if (status === 403 && message === 'Request not allowed' && !url.includes('/me/permissions')) {
      failureHandlers.onForbidden?.();
    }

    return Promise.reject(error);
  }
);

export default api;
